module.exports = __webpack_public_path__ + "img/f_1.c24ca158.png";